class MegaMenuLink extends HTMLElement {
  get $refs() {
    return {
      mainMenusContainer: this.querySelector('[data-element-ref="main-menus-container"]'),
      secondaryMenusContainer: this.querySelector('[data-element-ref="secondary-menus-container"]'),
      topLevelMenuContainer: this.querySelector('[data-element-ref="top-level-menu-container"]'),
      submenusContainer: this.querySelector('[data-element-ref="submenus-container"]'),
      featuredImagesWrapper: this.querySelector('[data-element-ref="featured-images-wrapper"]'),
    }
  }

  connectedCallback() {
    const type = this.getAttribute('type')

    if (type === 'links-with-images') {
      this.setupSubmenuEvents()
      this.setupFeaturedImageEvents('main')
      this.setupFeaturedImageEvents('secondary')

      this.showActiveDefault()
    }
  }

  showActiveDefault() {
    this.showSubmenu('0')
    this.showFeaturedImage('main', 0)
  }

  setupSubmenuEvents() {
    const linksWithSubmenus = this.$refs.topLevelMenuContainer.querySelectorAll('li[data-submenu-index]')
    linksWithSubmenus.forEach((link) => {
      link.addEventListener('mouseenter', () => this.showSubmenu(link.dataset.submenuIndex))
    })

    const linksWithoutSubmenus = this.$refs.topLevelMenuContainer.querySelectorAll('li:not([data-submenu-index])')
    linksWithoutSubmenus.forEach((link) => {
      link.addEventListener('mouseenter', this.hideCurrentSubmenu.bind(this))
    })

    if (!this.$refs.mainMenusContainer) {
      console.warn('main-menus-container element not found, submenus will be stucked after being shown')
    } else {
      this.$refs.mainMenusContainer.addEventListener('mouseleave', () => {
        this.hideCurrentSubmenu()
        this.hideCurrentFeaturedImage()
        this.showActiveDefault()
      })
    }
  }

  showSubmenu(index) {
    const $link = this.$refs.topLevelMenuContainer.querySelector(`[data-submenu-index="${index}"]`)
    const $submenu = this.$refs.submenusContainer.querySelector(`[data-submenu-index="${index}"]`)

    if (!$submenu) {
      console.warn(`trying to show submenu with index ${index} but it doesn't exist`)
      return
    }

    this.hideCurrentSubmenu()
    $link.classList.add('is-active')
    $link.parentNode.classList.add('has-active-link')
    $submenu.classList.add('is-active')
  }

  hideCurrentSubmenu() {
    const $currentLink = this.$refs.topLevelMenuContainer.querySelector('.is-active')
    const $currentSubmenu = this.$refs.submenusContainer.querySelector('.is-active')

    $currentLink && $currentLink.classList.remove('is-active')
    $currentLink && $currentLink.parentNode.classList.remove('has-active-link')
    $currentSubmenu && $currentSubmenu.classList.remove('is-active')
  }

  /**
   *
   * @param {'main' | 'secondary'} menu
   */
  setupFeaturedImageEvents(menu) {
    let container = null

    switch (menu) {
      case 'main':
        // Note: Without query selector will includes secondary menu links
        container = this.$refs.mainMenusContainer.querySelector('* > .mega-menu-dropdown__menu > ul')
        break
      case 'secondary':
        container = this.$refs.secondaryMenusContainer
        break
      default:
        console.warn(`unknown menu ${menu}, images won't be shown`)
        return
    }

    container.querySelectorAll('li').forEach((link, index) => {
      const featuredImagePerLinkIndex = this.querySelector(
        `[data-featured-image-menu="${menu}"][data-featured-image-index="${index}"]`
      )

      if (!featuredImagePerLinkIndex) {
        link.addEventListener('mouseenter', this.hideCurrentFeaturedImage.bind(this))
        return
      }

      link.addEventListener('mouseenter', () => this.showFeaturedImage(menu, index))
    })

    if (!this.$refs.mainMenusContainer) {
      console.warn('main-menus-container element not found, featured images will be stucked after being shown')
    } else {
      this.$refs.mainMenusContainer.addEventListener('mouseleave', this.hideCurrentFeaturedImage.bind(this))
    }
  }

  /**
   *
   * @param {'main' | 'secondary'} menu
   * @param {string} index
   * @returns
   */
  showFeaturedImage(menu, index) {
    const $featuredImage = this.$refs.featuredImagesWrapper.querySelector(
      `[data-featured-image-menu="${menu}"][data-featured-image-index="${index}"]`
    )

    if (!$featuredImage) {
      console.warn(`trying to show featured image with index ${index} but it doesn't exist`)
      return
    }

    this.hideCurrentFeaturedImage()
    window.requestAnimationFrame(() => {
      $featuredImage.classList.add('is-active')
    })
  }

  hideCurrentFeaturedImage() {
    const $current = this.$refs.featuredImagesWrapper.querySelector('.is-active')

    if (!$current) {
      return
    }

    $current.classList.remove('is-active')
  }
}

if (!customElements.get('mega-menu-link')) {
  customElements.define('mega-menu-link', MegaMenuLink)
}
